const { updateAngularUi } = require('@/functions/angular');
/**
 * Holds the current state of paying for an order.
 * This means things like can payment be cancelled at this point, and a message to show on success.
 *
 * @constructor
 */
const PaymentState = function () {
    /**
     * Can the payment be cancelled at the modal level? (i.e. using the modal's own 'Cancel' button at bottom left)
     * Individual payment methods should control whether they themselves are cancellable.
     *
     * @type {?boolean}
     */
    this.paymentModalCancelable = null;

    /**
     * Which Payment Method decided it could or could not be cancelled?
     *
     * @type {?string}
     */
    this.paymentModalCancelableSetByPaymentMethodRef = null;

    /**
     * @type {?string}
     */
    this.successMessage = null;
};

PaymentState.prototype = {
    /**
     * @param {boolean} cancelable
     * @param {string} setByPaymentMethodRef
     */
    setPaymentModalCancelable(cancelable, setByPaymentMethodRef) {
        this.paymentModalCancelable = cancelable;
        this.paymentModalCancelableSetByPaymentMethodRef = setByPaymentMethodRef;
        updateAngularUi();
    },

    clearPaymentModalCancelable() {
        this.paymentModalCancelable = null;
        this.paymentModalCancelableSetByPaymentMethodRef = null;
        updateAngularUi();
    },

    /**
     * Set some text that should be displayed on the change modal, for cases when something should be
     * shown to the operator but the payment modal has already been automatically dismissed.
     * For example, a card payment is taken and the payment modal automatically submits. In this case,
     * the user was never shown the transaction result.
     *
     * @param {string} text
     */
    setSuccessMessage(text) {
        this.successMessage = text;
    },

    /**
     * Return the success message string and clear it.
     *
     * @return {?string}
     */
    pullSuccessMessage() {
        let message = this.successMessage;
        this.clearSuccessMessage();
        return message;
    },

    clearSuccessMessage() {
        this.successMessage = null;
    },
};

module.exports = PaymentState;
